import React, {useContext, useEffect, useState} from "react";
import {Checkbox, Divider} from "antd";
import GenericDialog from "@common/GenericDialog";
import {SettingsIcon} from "@common/icons";
import {BrandContext} from "@common/context/BrandContext";
import {UserContext} from "@common/context/UserContext";

interface StartBulkClassUpdateDialogProps {
    open: boolean,
    setClose: () => void,
    callback: () => void
}

const StartBulkClassUpdateDialog: React.FC<StartBulkClassUpdateDialogProps> = (props) => {
    const {open = true, setClose, callback} = props;
    const [dialogOpen, setDialogOpen] = useState<boolean>(open);
    const [isConfirmed, setIsConfirmed] = useState<boolean>(false);
    const { user } = useContext<any>(UserContext);
    const brandName = user?.brand?.shortName;

    useEffect(() => {
        setDialogOpen(open);
        setIsConfirmed(false);
    }, [open]);

    const handleContinue = (): void => {
        setDialogOpen(false);
        if (callback && typeof callback === 'function') callback();
    }

    const handleCloseDialog = (): void => {
        setDialogOpen(false);
        if (setClose && typeof setClose === 'function') setClose();
    }

    return (
        <GenericDialog
            title="Import Classes"
            dialogWidth={450}
            open={dialogOpen}
            onClose={handleCloseDialog}
            buttons={[
                {name: 'Continue', callback: async () => handleContinue(), disabled: !isConfirmed},
                {name: 'Cancel', extraProps: {type: 'outline'}, callback: async () => handleCloseDialog()}
            ]}>
            <p>
                Your user account is able to manage classes across multiple subject areas.
                If you want to manage classes for a subject other than {brandName}, please change to that subject area using
                the <SettingsIcon style={{verticalAlign: "middle"}} /> icon in the navigation.
            </p>
            <Divider className={'ch-divider'} />
            <Checkbox
                checked={isConfirmed}
                onChange={(e) => setIsConfirmed(e.target.checked)}
                aria-label={`Confirm uploading classes for ${brandName}`}
                id="confirm-maths-upload"
            >
                I am uploading classes for <strong>{brandName}</strong>.
            </Checkbox>
        </GenericDialog>
    )
}

export default StartBulkClassUpdateDialog;